import React from "react";
import { createApi } from "../../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { universalAPIErrorHandler } from "../../../../utils/universalAPIErrorHandler";
import { getNumbersAfterAboutSite } from "../SiteAbout";
import { NavigateFunction } from "react-router-dom";
import { ExtraFields, SiteInfo } from "./siteAboutInterfaces";
import { GeneralInfoTab } from "../GeneralInfoTab";

export const handleSubmitUpdatedNotes = (
  newNotes: string,
  backupNotes: string,
  setSiteInfo: React.Dispatch<React.SetStateAction<SiteInfo>>,
  setActiveTab:
    | React.Dispatch<React.SetStateAction<JSX.Element>>
    | null
    | undefined,
  navigate: NavigateFunction
): Promise<void> => {
  const AxiosUI = createApi(``);

  const retryFunction = () => {
    handleSubmitUpdatedNotes(
      newNotes,
      backupNotes,
      setSiteInfo,
      setActiveTab,
      navigate
    );
  };

  return AxiosUI.patch(
    `customer/${getNumbersAfterAboutSite(location.href)}/about/`,
    { notes: newNotes }
  )
    .then((response: AxiosResponse) => {
      const siteInfo = response.data;
      setSiteInfo((previousState: SiteInfo) => ({
        ...previousState,
        ...siteInfo,
        notes: newNotes,
      }));
      if (setActiveTab) {
        setActiveTab(<></>);
        const newVMSVariables: any[] = [];
        siteInfo.extra_fields?.forEach((object: ExtraFields) => {
          const newArray: any[] = [
            `${object.label}`,
            `${siteInfo[object.id]}`,
            `${object.id}`,
            `${object.type}`,
            object.choices,
          ];
          object.choices
            ? (newArray[4] = object.choices)
            : (newArray[4] = object.options);
          // ENG-2535: [5] = visible_when display rule (absent = always shown)
          newArray[5] = object.visible_when;
          newVMSVariables.push(newArray);
        });
        setActiveTab(
          <GeneralInfoTab
            siteInfo={siteInfo}
            setSiteInfo={setSiteInfo}
            setActiveTab={setActiveTab}
            vmsVariables={newVMSVariables}
          />
        );
      }
    })
    .catch((reason: AxiosError) => {
      return new Promise<void>((_, reject) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          setSiteInfo((previousState: SiteInfo) => ({
            ...previousState,
            notes: backupNotes,
          }));
          alert("Notes could not be updated. Please try again.");
          reject(reason);
        });
      });
    });
};
